"use client";
import { observer } from "mobx-react-lite";
import React, { Suspense, useRef, useEffect } from "react";
import type { FC, ExoticComponent } from "react";
import type { ReactNode } from "react";
import { useLocation } from "react-router";

export type ActivityMode = "visible" | "hidden";

/**
 * @deprecated
 */
export type OffscreenMode = ActivityMode;

export interface IProps {
    mode: ActivityMode;
    children: ReactNode;
    currentPath: string;
}export

const canUseDOM = () =>
    !!(
        typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined'
    );

const globalDict: { [key: string]: {
    promise: Promise<void> | null;
    resolve: (() => void) | null;
} } = {};

// export const Repeater: FC<IProps> = (props) => {
//     // props
//     const { mode, children, currentPath } = props;
//     // refs
//     // const promiseRef = useRef<Promise<void> | null>(null);
//     // const resolveRef = useRef<(() => void) | null>(null);

//     // methods
//     const resolvePromise = (ignore?: boolean) => {
//         console.log("resolve promise", currentPath, mode, ignore, typeof globalDict[currentPath].resolve === "function");
//         if (
//             (ignore || mode === "visible") &&
//             typeof globalDict[currentPath].resolve === "function"
//         ) {
//             console.log(currentPath, {...globalDict});
//             globalDict[currentPath].resolve();
//             globalDict[currentPath].resolve = null;
//             globalDict[currentPath].promise = null;
//         }
//     };
//     // effect
//     useEffect(() => () => resolvePromise(true), []);

//     if (globalDict[currentPath] === undefined) {
//         globalDict[currentPath] = {
//             promise: null,
//             resolve: null,
//         };
//     }

//     if (mode === "hidden") {
//         if (globalDict[currentPath].resolve === null) {
//             globalDict[currentPath].promise = new Promise<void>(
//                     (resolve) => (globalDict[currentPath].resolve = resolve),
//                 )
//         }

//         const promise = globalDict[currentPath].promise!;

//         if ("use" in React && typeof React.use === "function") {
//             (React.use as <T>(primise: Promise<T>) => T)(promise);
//         } else {
//             throw promise;
//         }
//     }

//     resolvePromise();

//     return children;
// };

export const Repeater: FC<IProps> = observer((props) => {
    // props
    const { mode, children, currentPath } = props;
    // refs
    const promiseRef = useRef<Promise<void> | null>(null);
    const resolveRef = useRef<(() => void) | null>(null);
    
    // methods
    const resolvePromise = (ignore?: boolean) => {
        if (
            (ignore || mode === "visible") &&
            typeof resolveRef.current === "function"
        ) {
            // console.log("resolve promise", currentPath, mode, ignore, typeof resolveRef.current === "function");
            resolveRef.current();
            resolveRef.current = null;
            promiseRef.current = null;
        }
    };
    // effect
    useEffect(() => () => resolvePromise(true), []);

    if (mode === "hidden") {
        // console.log("Repeater hidden mode", currentPath, mode, typeof resolveRef.current === "function");
        if (resolveRef.current === null) {
            promiseRef.current = new Promise<void>(
                (resolve) => (resolveRef.current = resolve),
            );
        }

        const promise = promiseRef.current!;
        if ("use" in React && typeof React.use === "function") {
            (React.use as <T>(primise: Promise<T>) => T)(promise);
        } else {
            throw promise;
        }
    }

    resolvePromise();

    return children;
});
const isSupportStableActivity = "Activity" in React;
const isBrowser = canUseDOM();

const NativeActivity = isSupportStableActivity
    ? // @ts-expect-error React.Activity is not yet fully typed in @types/react
    (React.Activity as ExoticComponent<IProps>)
    : "unstable_Activity" in React
        ? (React.unstable_Activity as ExoticComponent<IProps>)
        : null;

if (isBrowser && isSupportStableActivity) {
    console.warn("It is detected that the react version you are using already supports Activity natively. We recommend that you migrate to native Activity.",
    );
}

/**
 *
 * @param {IProps} props
 * @description This is a component that keeps its state while hiding it
 * @example
 * when visible
 * <Activity mode="visible">
 *  <Child />
 * </Activity>
 * when hidden
 * <Activity mode="hidden">
 *  <Child />
 * </Activity>
 */
export const Activity: FC<IProps> = (props) => {
    // props
    const { mode, children, currentPath } = props;

    if (NativeActivity) {
        return <NativeActivity mode={mode} currentPath={currentPath}>{children}</NativeActivity>;
    }

    return (
        <Suspense fallback={null}>
            <Repeater mode={mode} currentPath={currentPath}>{children}</Repeater>
        </Suspense>
    );
};

/**
 * @deprecated
 * @description please rename Offscreen to Activity
 */
export const Offscreen: FC<IProps> = Activity;